import { faAngleLeft, faCheck, faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';
import { DELETE_ACCOUNT_STEPS, useDeleteAccountContext } from '../DeleteAccount';
import { api } from '../../../../utils/api';
import { useForm } from '../../../../hooks/Form';
import { AxiosError } from 'axios';

export default function DeleteAccountStart() {
    const { setStep } = useDeleteAccountContext();
    const { error, setError, isLoading, setIsLoading } = useForm();

    /** @param {React.FormEvent<HTMLFormElement>} event */
    const handleSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        try {
            setIsLoading(true);

            await api.post('/deletion_requests', null, {
                validateStatus: (status) => status === 201
            });

            setStep(DELETE_ACCOUNT_STEPS.VERIFY);

        } catch (error) {
            if (error instanceof AxiosError && error.response.status === 403) {
                setError('It looks like you recently updated your email address. For security reasons, account deletion is only available 3 days after changing your email.');

            } else {
                setError('Something went wrong.');
            }

        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Fragment>
            <div className='container'>
                <nav className='nav'>
                    <Link to={-1} className='nav__button button button--white button--link button--icon'>
                        <FontAwesomeIcon icon={faAngleLeft} />
                    </Link>
                    <p className='nav__title'>
                        Delete your account
                    </p>
                </nav>
                <div className='panel'>
                    <form id='start-form' onSubmit={handleSubmit} className='panel__form form'>
                        <p className='form__title'>
                            Are you sure you want to delete your account?
                        </p>
                        {error && (
                            <p className='error error--white'>
                                {error}
                            </p>
                        )}
                    </form>
                </div>
                <div className='button-group'>
                    <Link to={-1} className='button button--primary button--outline'>
                        Cancel <FontAwesomeIcon icon={faClose} />
                    </Link>
                    <button type='submit' form='start-form' disabled={isLoading} className='button button--primary button--fill'>
                        {isLoading ? <>Loading...</> : <>Confirm <FontAwesomeIcon icon={faCheck} /></>}
                    </button>
                </div>
            </div>
        </Fragment>
    );
}